export default "__VITE_PUBLIC_ASSET__89fc7cd5__"